import { ValueObject, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class MissingAccountsSearchCriteria extends ValueObject {
    public searchCriteria: string = "";
}